import {get, post} from "./http"

function PaymentPlanAPI() {
	function pollConfirmation(paymentPlanID: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let numberOfTries = 0

			const intervalId = setInterval(() => {
				get(`/app/payment-plans-status/${paymentPlanID}`)
					.then((result: any) => {
						if (
							(result.Status !== "Initiated" && result.Status != "IntentSubmitted") ||
							numberOfTries === 59
						) {
							clearInterval(intervalId)
							resolve(result)
						}
						numberOfTries++
					})
					.catch((e) => {
						clearInterval(intervalId)
						reject(e)
					})
			}, 1000)
		})
	}

	function create({
		secureCode,
		paymentMethod,
		paymentPlanFrequency,
		instalmentAmount,
		payDay,
		startDate,
		aaid,
	}: {
		secureCode: string
		paymentMethod: string
		paymentPlanFrequency: string
		instalmentAmount: string
		payDay: string
		startDate: string
		aaid: string
	}) {
		return post(`/app/payment-plans/${secureCode}`, {
			PaymentMethod: paymentMethod,
			PaymentPlanFrequency: paymentPlanFrequency,
			InstalmentAmount: instalmentAmount,
			PayDay: payDay,
			StartDate: startDate,
			AffordabilityAssessmentID: aaid,
		})
	}

	function createForm({secureCode}: {secureCode: string}) {
		return get(`/app/payment-plans/${secureCode}`)
	}

	function getAmountPage({secureCode}: {secureCode: string}) {
		return get(`/app/payment-plans/${secureCode}/amount`)
	}

	function getTermsOfDiscountOffer({secureCode}: {secureCode: string}) {
		return get(`/app/payment-plans/${secureCode}/terms-of-discount-offer`)
	}

	function getActiveTermsOfDiscountOffer({paymentPlanID}: {paymentPlanID: string}) {
		return get(`/app/payment-plan/${paymentPlanID}/terms-of-discount-offer`)
	}

	function receiveIntentSubmitted({
		paymentPlanId,
		providerName,
		providerRawResponse,
	}: {
		paymentPlanId: string
		providerName: string
		providerRawResponse: string
	}) {
		return post(`/app/payment-plan/${paymentPlanId}/receive-intent-submitted`, {
			ProviderName: providerName,
			ProviderRawResponse: providerRawResponse,
		})
	}

	function payInstalment({paymentPlanId, instalmentId}: {paymentPlanId: string; instalmentId: string}) {
		return post(`/app/payment-plan/${paymentPlanId}/pay-instalment`, {
			InstalmentID: instalmentId,
		})
	}

	function settlePaymentPlan({paymentPlanId}: {paymentPlanId: string}) {
		return post(`/app/payment-plan/${paymentPlanId}/initiate-settlement`)
	}

	function pollPaymentPlanStatus(paymentPlanId: string) {
		return new Promise((resolve, reject) => {
			const intervalId = setInterval(() => {
				pollConfirmation(paymentPlanId)
					.then((result: any) => {
						if (result.SettlementInProgress === false) {
							clearInterval(intervalId)
							resolve(result)
						}
					})
					.catch((e) => {
						clearInterval(intervalId)
						reject(e)
					})
			}, 1000)
		})
	}

	function pollPayInstalmentConfirmation(paymentPlanId: string): Promise<any> {
		return new Promise((resolve, reject) => {
			const intervalId = setInterval(() => {
				get(`/app/payment-plan/${paymentPlanId}/instalment-status`)
					.then((result: any) => {
						if (result.Status !== "Initiated") {
							clearInterval(intervalId)
							resolve(result)
						}
					})
					.catch((e) => {
						clearInterval(intervalId)
						reject(e)
					})
			}, 1000)
		})
	}

	function cancel(paymentPlanId: string) {
		return post(`/app/payment-plan/${paymentPlanId}/cancel`, {})
	}

	return {
		pollConfirmation,
		create,
		createForm,
		getAmountPage,
		getTermsOfDiscountOffer,
		getActiveTermsOfDiscountOffer,
		receiveIntentSubmitted,
		payInstalment,
		pollPayInstalmentConfirmation,
		cancel,
		settlePaymentPlan,
		pollPaymentPlanStatus,
	}
}

const paymentPlanAPI = PaymentPlanAPI()

export {paymentPlanAPI}
